import {createSlice} from "@reduxjs/toolkit";
import {getScheduleList} from "./action";

const initialState = {
	state: {
		items: [],
		paging: {}
	},
	loading: true,
	error: ''
} as BaseState<ScheduleState>

const slice = createSlice({
	name: 'scheduleSlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getScheduleList.pending, (state) => ({
				...state,
				loading: true
			})
		)
		builder.addCase(getScheduleList.fulfilled, (state, action) => {
				const { items, paging } = action.payload
				return {
					state: {
						items,
						paging
					},
					loading: false,
					error: null
				}
			}
		)
		builder.addCase(getScheduleList.rejected, () => ({
				state: {
					items: []
				},
				loading: false,
				error: 'Failed to get facts, please try again'
			})
		)
	}
})

export default slice
